import { render, staticRenderFns } from "./ItemReceived.vue?vue&type=template&id=05af3e38&scoped=true"
import script from "./ItemReceived.vue?vue&type=script&lang=js"
export * from "./ItemReceived.vue?vue&type=script&lang=js"
import style0 from "./ItemReceived.vue?vue&type=style&index=0&id=05af3e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af3e38",
  null
  
)

export default component.exports